import { extend, Object3DNode } from '@react-three/fiber';
import {
  ColliderHelper,
  Instance,
  Instances,
  SurfacePathTravelHelper,
} from '@spazious/dollhouse-three';

extend({ ColliderHelper, Instances, Instance, SurfacePathTravelHelper });

declare global {
  namespace JSX {
    interface IntrinsicElements {
      colliderHelper: Object3DNode<ColliderHelper, typeof ColliderHelper>;
      instances: Object3DNode<Instances, typeof Instances>;
      instance: Object3DNode<Instance, typeof Instance>;
      surfacePathTravelHelper: Object3DNode<
        SurfacePathTravelHelper,
        typeof SurfacePathTravelHelper
      >;
    }
  }
}
